import { render, staticRenderFns } from "./uide-B11.vue?vue&type=template&id=49b1f1b0&scoped=true"
import script from "./uide-B11.vue?vue&type=script&lang=js"
export * from "./uide-B11.vue?vue&type=script&lang=js"
import style0 from "./uide-B11.vue?vue&type=style&index=0&id=49b1f1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1f1b0",
  null
  
)

export default component.exports